import { useState, useEffect } from 'react'

const useWaitingText = ({ baseText = 'Aguarde', active = false }) => {
  const [dotCount, setDotCount] = useState(0)

  useEffect(() => {
    if (!active) {
      setDotCount(0)
      return
    }

    const interval = setInterval(() => {
      setDotCount((prev) => (prev + 1) % 4)
    }, 500)

    return () => clearInterval(interval)
  }, [active])

  return baseText + '.'.repeat(dotCount)
}

export default useWaitingText
